//@flow
const vendorStateName = 'vendor'
const localStore = localStorage.getItem(vendorStateName)

export const vendorInitialState: any = localStore ? JSON.parse(localStore) : {
    vendor: {
        vendors: [],
        count: 0,
        currentVendor: null,
        loading: false,
        error: '',
        search: '',
        filters: {
            is_enabled: null,
            is_recur: null,
            type_of_invoice: ''
        },
        pagination: {
            page: 1,
            pageSize: 20,
            pages: 0
        },
        sortField: 'id',
        sortOrder: 'asc',
    }
}

type State = {
    +vendor: {
        +vendors: Array<any>,
        +count: number,
        +currentVendor: any,
        +loading: boolean,
        +error: string,
        +search: string,
        +filters: {
            +is_enabled: ?boolean,
            +is_recur: ?boolean,
            +type_of_invoice: string
        },
        +pagination: {
            +page: number,
            +pageSize: number,
            +pages: number
        },
        +sortField: string,
        +sortOrder: string
    }
}

type Action = {
    vendors?: Array<any>,
    count?: number,
    vendor?: any,
    error?: string,
    search?: string,
    filters?: any,
    pagination?: any,
    pageSize?: number,
    page?: number,
    pages?: number,
    sortField?: string,
    sortOrder?: string
}

export const ActionLoadVendors = 'loadVendors'
export const ActionLoadVendorsSuccess = 'loadVendorsSuccess'
export const ActionLoadVendorsError = 'loadVendorsError'
export const ActionSelectVendor = 'selectVendor'
export const ActionCreateVendor = 'createVendor'
export const ActionCreateVendorSuccess = 'createVendorSuccess'
export const ActionUpdateVendor = 'updateVendor'
export const ActionUpdateVendorSuccess = 'updateVendorSuccess'
export const ActionDeleteVendor = 'deleteVendor'
export const ActionDeleteVendorSuccess = 'deleteVendorSuccess'
export const ActionSetSearchTerm = 'setSearchTerm'
export const ActionSetFilters = 'setFilters'
export const ActionSetPagination = 'setPagination'
export const ActionSetOrderBy = 'setOrderBy'
export const ActionClearError = 'clearError'

export const vendorActions: any = {
    [ActionLoadVendors]: (state: State) => {
        const vendorState = { 
            vendor: { 
                ...state.vendor, 
                loading: true, 
                error: '' 
            } 
        };
        localStorage.setItem(vendorStateName, JSON.stringify(vendorState))
        return vendorState
    },
    [ActionLoadVendorsSuccess]: (state: State, action: Action) => {
        const vendorState = { 
            vendor: { 
                ...state.vendor, 
                vendors: action.vendors || [],
                count: action.count || 0,
                pagination: { 
                    ...state.vendor.pagination,
                    page: action.page || 1, 
                    pageSize: action.pageSize || 20,
                    pages: action.pages || 0
                },
                sortField: action.sortField || state.vendor.sortField,
                sortOrder: action.sortOrder || state.vendor.sortOrder,
                loading: false, 
                error: '' 
            } 
        };
        localStorage.setItem(vendorStateName, JSON.stringify(vendorState))
        return vendorState
    },
    [ActionLoadVendorsError]: (state: State, action: Action) => {
        const vendorState = { 
            vendor: { 
                ...state.vendor, 
                loading: false, 
                error: action.error || 'Failed to load vendors' 
            } 
        };
        localStorage.setItem(vendorStateName, JSON.stringify(vendorState))
        return vendorState
    },
    [ActionSelectVendor]: (state: State, action: Action) => {
        const vendorState = { 
            vendor: { 
                ...state.vendor, 
                currentVendor: action.vendor 
            } 
        };
        localStorage.setItem(vendorStateName, JSON.stringify(vendorState))
        return vendorState
    },
    [ActionCreateVendorSuccess]: (state: State, action: Action) => {
        const vendors = [...state.vendor.vendors, action.vendor];
        const vendorState = { 
            vendor: { 
                ...state.vendor, 
                vendors,
                count: state.vendor.count + 1,
                error: '' 
            } 
        };
        localStorage.setItem(vendorStateName, JSON.stringify(vendorState))
        return vendorState
    },
    [ActionUpdateVendorSuccess]: (state: State, action: Action) => {
        const vendors = state.vendor.vendors.map(v => 
            v.id === action.vendor?.id ? action.vendor : v
        );
        const vendorState = { 
            vendor: { 
                ...state.vendor, 
                vendors,
                currentVendor: action.vendor,
                error: '' 
            } 
        };
        localStorage.setItem(vendorStateName, JSON.stringify(vendorState))
        return vendorState
    },
    [ActionDeleteVendorSuccess]: (state: State, action: Action) => {
        const vendors = state.vendor.vendors.filter(v => v.id !== action.vendor?.id);
        const vendorState = { 
            vendor: { 
                ...state.vendor, 
                vendors,
                count: state.vendor.count - 1,
                currentVendor: state.vendor.currentVendor?.id === action.vendor?.id ? null : state.vendor.currentVendor,
                error: '' 
            } 
        };
        localStorage.setItem(vendorStateName, JSON.stringify(vendorState))
        return vendorState
    },
    [ActionSetSearchTerm]: (state: State, action: Action) => {
        const vendorState = { 
            vendor: { 
                ...state.vendor, 
                search: action.search || '',
            } 
        };
        localStorage.setItem(vendorStateName, JSON.stringify(vendorState))
        return vendorState
    },
    [ActionSetFilters]: (state: State, action: Action) => {
        const vendorState = { 
            vendor: { 
                ...state.vendor, 
                filters: { ...state.vendor.filters, ...action.filters },
            } 
        };
        localStorage.setItem(vendorStateName, JSON.stringify(vendorState))
        return vendorState
    },
    [ActionSetPagination]: (state: State, action: Action) => {
        const vendorState = { 
            vendor: { 
                ...state.vendor, 
                pagination: { ...state.vendor.pagination, ...action.pagination }
            } 
        };
        localStorage.setItem(vendorStateName, JSON.stringify(vendorState))
        return vendorState
    },
    [ActionSetOrderBy]: (state: State, action: Action) => {
        const vendorState = { 
            vendor: { 
                ...state.vendor, 
                sortField: action.sortField || 'id',
                sortOrder: action.sortOrder || 'asc'
            } 
        };
        localStorage.setItem(vendorStateName, JSON.stringify(vendorState))
        return vendorState
    },
    [ActionClearError]: (state: State) => {
        const vendorState = { 
            vendor: { 
                ...state.vendor, 
                error: '' 
            } 
        };
        localStorage.setItem(vendorStateName, JSON.stringify(vendorState))
        return vendorState
    }
};

export const getStateName = (): string => vendorStateName;
